import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form--suppress-enter-submit"
//
// Prevents the Enter key from submitting the form when pressed inside a
// single-line input. Replaces inline jQuery handlers that would re-bind on
// every turbo-frame re-render, stacking duplicate listeners on the form.
export default class extends Controller {
  prevent(event) {
    if (event.key === "Enter") {
      event.preventDefault()
    }
  }
}
